import { useTranslate } from '@tolgee/react'
import { GeneralIcon, SwapBodyIcon, TrailerIcon } from '@tom-ui/ui'

export type UnitType = 'Container' | 'SwapBody' | 'Trailer'

export const useUnitTypeIcon = (unitType?: UnitType) => {
  switch (unitType) {
    case 'SwapBody':
      return <SwapBodyIcon />
    case 'Trailer':
      return <TrailerIcon />
    default:
      return <GeneralIcon />
  }
}

export const useUnitTypeLabel = (unitType?: UnitType) => {
  const { t } = useTranslate()

  switch (unitType) {
    case 'SwapBody':
      return t('swapBody', 'Swap Body')
    case 'Trailer':
      return t('trailer', 'Trailer')
    default:
      return t('container', 'Container')
  }
}
